import router from './router'
import store from './store'
import localData from './common/localdata'
import config from './config'

/**
 * 处理远程debug
 * @param {object} to 路由的to
 */
const prepareRemoteDebug = (to) => {
  if (to.query.debug) {
    localData.set('debugMode', !!to.query.debug)
  } else {
    localData.set('debugMode', false)
  }
}

/**
 * 检测是否必需登录
 * @param {object} to   路由的to
 * @param {object} next 路由的next
 */
const checkIfNeedLogin = (to, next) => {
  // 不需要登录后访问的页面
  const noLoginRequired = config.routeNoLoginRequired || []

  // 当前登录状态
  const loginStatus = store.state.user.loginStatus

  // 未登录时检测目标地址是否必需要登录
  if (loginStatus < 2 && !noLoginRequired.includes(to.name)) {
    next({
      name: 'Login',
      query: {
        redirect: to.fullPath
      }
    })
  } else {
    next()
  }
}

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  prepareRemoteDebug(to)
  return checkIfNeedLogin(to, next)
})
